import axios from 'axios';
import { API_URL, MASTERAPIHOME, LATESTMASTERAPIHOME } from './config';
import MasterDataDef, { GetPageTitle } from '../sections/master/MasterDataDef';
import MasterRowDef from '../sections/master/masaterrowdatadef';

const fileheaders = { 'content-type': 'multipart/form-data' };

class MastersService {

    constructor() {

        this.Masters = (masterName) => (axios.get(`${MASTERAPIHOME}${masterName}`));

        this.GetRows = (masterName, noOfRecords) => (axios.post(`${MASTERAPIHOME}getcurrentmaster`, { masterName, noOfRecords }));

        this.GetColumns = (masterName) => (MasterDataDef(masterName));

        this.GetRowData = (masterName) => (MasterRowDef(masterName));

        this.GetPageTitle = (masterName) => (GetPageTitle(masterName));

        this.GetUpdateHistoryColumns = () => (MasterDataDef("importhistory"));

        this.GetUpdateHistory = (masterName) => (axios.post(`${MASTERAPIHOME}getmastertrackhistory`, { masterName }));

        this.GetRecordUpdateHistory = (masterName, keyColumn, keyColumnValue) => (axios.post(`${MASTERAPIHOME}getrecordhistory`, { masterName, MasterRecId: keyColumnValue }));

        // File upload
        this.uploadMasterFile = (payload) => (axios.post(`${MASTERAPIHOME}uploadfile`, payload, fileheaders));

        this.GetImportPreviewColumns = (masterName) => (MasterDataDef(`${masterName}importpreview`));

        this.ImportMasterEnties = (masterName, trackId, dataCode) => (axios.post(`${MASTERAPIHOME}importmasterentries`, { masterName, trackId, dataCode }));

        this.GetLatestMasterImportTrack = (masterName) => (axios.post(`${LATESTMASTERAPIHOME}getlatestmasterimporttrack`, { masterName }));

        this.DeleteMasterAndHistoryRecords = (payload) => (axios.post(`${MASTERAPIHOME}deletemasterandhistoryrecords`, payload));

        this.GetMasterDataCount = (masterName) => (axios.post(`${MASTERAPIHOME}getmasterdatacount`, { masterName }));

        // get current master data for sales
        this.GetCurrentDataForSales = (payload) => (axios.post(`${MASTERAPIHOME}getcurrentdataforsales`, payload));

        this.GetMasterDataCountForSales = (payload) => (axios.post(`${MASTERAPIHOME}getmasterdatacountforsales`, payload));

        this.GetMasterTrackHistoryForSales = (payload) => (axios.post(`${MASTERAPIHOME}getmastertrackhistoryforsales`, payload));

        this.GetCurrentMasterForSales = (payload) => (axios.post(`${MASTERAPIHOME}getcurrentmasterforsales`, payload));
    }
}
export default new MastersService();